import script from "./QuanLyTaiNguyen.vue?vue&type=script&setup=true&lang=js"
export * from "./QuanLyTaiNguyen.vue?vue&type=script&setup=true&lang=js"

import "./QuanLyTaiNguyen.vue?vue&type=style&index=0&id=3c54c6fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c54c6fa"]])

export default __exports__